import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const APRIL_2026_CAMPAIGN_END_DATE = d(2026, 5, 31, 12, 0);
